import { useTranslation } from 'react-i18next';

const useUserRoles = () => {
    const { t } = useTranslation();

    const userRolesOptions = [
        {
            value: 'manager',
            label: t('Users.roles.manager'),
        },
        {
            value: 'executor',
            label: t('Users.roles.executor'),
        },
    ];

    return { userRolesOptions };
};

export default useUserRoles;
